module.exports = __webpack_public_path__ + "img/dongji_ps_26.ddbda513.jpg";